import { useState, useEffect } from "react";
import styled from "styled-components";
import { Text } from "../../components/Text";
import { Flex } from "../../components/Flex";
import Toggle from "../../components/Toggle";
import { Box } from "../../components/Box";
import { useSettings } from "../../Settings";

const SettingsLabel = styled.label`
  width: 150px;
  display: block;
  font-weight: 600;
`;

const getNotificationPermission = () => {
  if ("Notification" in window) {
    return Notification.permission;
  } else {
    return "unsupported";
  }
};

const NotificationSettings = () => {
  const [settings, setSettings] = useSettings();
  const [permission, setPermission] = useState(getNotificationPermission);

  const setEnabled = (v: boolean) => {
    setSettings((old) => ({
      ...old,
      enableNotifications: v
    }));
  };

  useEffect(() => {
    const notificationsEnabled =
      "Notification" in window && settings.enableNotifications;

    if (notificationsEnabled) {
      Notification.requestPermission().then(setPermission);
    }
  }, [settings]);

  return (
    <div>
      <Text fontWeight={600} fontSize={4} mb={3}>
        Notification Settings
      </Text>
      <Flex alignItems="center" mb={2}>
        <SettingsLabel>Enable Notifications</SettingsLabel>
        <Box ml={2}>
          <Toggle value={settings.enableNotifications} onChange={setEnabled} />
        </Box>
      </Flex>
      {permission === "denied" && (
        <Text color="danger">
          Your browser is set to block notifications from Aika.
        </Text>
      )}
      {permission === "unsupported" && (
        <Text color="danger">
          Your browser doesn't support notifications. Kill Safari.
        </Text>
      )}
    </div>
  );
};

export default NotificationSettings;
